import React from 'react';
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";

import { phoneRegex } from '../../utils/Regex';
import { createAdmin } from '../../services/super-admin.service';

import BackIcon from '../../assets/images/back_icon.svg'
import CreateIcon from '../../assets/images/create_icon.svg'

import ArrowleftIcon from "../../assets/images/arrowleft_icon.svg";


const MakeTransaction = ({ back }) => {

    const handleClose = () => {

        resetForm();
        setErrors({});
        back(false)
    }

    // form 

    const { handleBlur, handleChange, handleSubmit, values, errors, touched, resetForm, setErrors } = useFormik({
        initialValues: {
            projectName: null
        },
        validationSchema: Yup.object({
            projectName: Yup.string()
                .max(50, "First Name must be at most 50 characters")
                .required("FirstName is required")
        }),
        onSubmit: async (values, { resetForm }) => {
            try {

                const payload = {
                    Name: values.locationName,
                    Type: values.locationType,
                    ParentId:''
                }

                const res = await createAdmin(payload)

                if (res?.status === 200 && res?.data?.statusCode === 200) {
                    toast.success(res.data.message)
                    resetForm();
                    setErrors({});
                    back()

                } else {
                    toast.error(res?.message || res?.data?.message);
                }
            } catch (error) {
                if (error?.message) {
                    const msg = error?.message?.split(":")?.[1]?.trim();
                    console.error(msg)


                }
                console.log(error.message);
            }
        },
    });

    return (
        <div className='whiteFrame'>
            <div className="mb_24 displayFlex alignItem_center gap12">
                <div>
                    <button
                        className="emptyBtn"
                        type="button"
                        onClick={handleClose}
                    >
                        <img src={ArrowleftIcon} alt="ArrowleftIcon" />
                    </button>

                </div>
                <div>
                    <h5 className='fontSize20 fontWeight600 blackClr_text'> Add Location</h5>
                </div>
               
            </div>




            <form onSubmit={handleSubmit}>
                <div className='row'> 
                <div className="mb_24 col-md-6">
                    <label
                        className="fontSize14 fontWeight500 blackClr_text display_block mb_8"
                        htmlFor="fn"
                    >
                        Location Name                    </label>
                    <input
                        className="MainInput"
                        type="text"
                        placeholder="Enter Location Name"
                        id="locationName"
                        name="locationName"
                        value={values.locationName}
                        onBlur={handleBlur}
                        onChange={handleChange}
                    />
                    {errors.locationName && touched.locationName ? (
                        <p className="fontSize12 fontWeight500 errorClr_text mt_8">
                            {errors.locationName}
                        </p>
                    ) : (
                        <></>
                    )}
                </div>

                <div className="mb_24 col-md-6">
                    <label
                        className="fontSize14 fontWeight500 blackClr_text display_block mb_8"
                        htmlFor="fn"
                    >
                        Type                    </label>
                    <input
                        className="MainInput"
                        type="text"
                        placeholder="Enter Location Type"
                        id="locationType"
                        name="locationType"
                        value={values.locationType}
                        onBlur={handleBlur}
                        onChange={handleChange}
                    />
                    {errors.locationType && touched.locationType ? (
                        <p className="fontSize12 fontWeight500 errorClr_text mt_8">
                            {errors.locationType}
                        </p>
                    ) : (
                        <></>
                    )}
                </div>

                </div>
                {/* ========= Submit Button ========= */}
                {/* <div className='justifyContent_end displayFlex'>
                    <div> */}
                        <button type="submit" className="MainButton cyanSky_clr gap8">
                            <img className='width20px' src={CreateIcon} alt="CreateIcon" />
                            <span>Create Location</span>
                        </button>
                    {/* </div>
                </div> */}
            </form>





        </div>
    )
}

export default MakeTransaction